import { AustralianState, CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';
import { Feature } from '@urbanx/agx.agencies.client';

export const useFeatureToggles = (
  state?: AustralianState | CampaignDetailModelState
): { isLoading: boolean; isEnabled: (feature: Feature) => boolean } => {
  const { featureToggles } = useAppSelector((state) => state.agentInfo);

  if (!featureToggles) return { isLoading: true, isEnabled: () => false };

  const enabledFeatures = state
    ? featureToggles.enabledFeaturesByState?.[state]
    : featureToggles.enabledFeatures;
  const enabledFeatureNames = new Set(enabledFeatures ?? []);

  return {
    isLoading: false,
    isEnabled: (feature) => enabledFeatureNames.has(feature),
  };
};
